














































import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { AxiosError } from "axios";
import _ from "@/boot/lodash";

// Providers

import ImportUploadFilesProvider from "@/components/app/admin/imports/importUploadFilesProvider.vue";

// Types
import { IBrand } from "@/models/brands";

@Component({
  computed: {
    ...mapState({
      brandId: (state: IState) => state.auth.admin.brandId
    })
  },
  components: {
    "import-upload-files-provider": ImportUploadFilesProvider,
    "file-upload-button": () =>
      import("@/components/app/global/files/fileUploadButton.vue"),
    "file-list": () => import("@/components/app/global/files/fileList.vue")
  }
})
export default class UploadFilesModal extends Vue {
  // Map state

  public brandId!: IBrand["id"];

  // Refs

  public declare $refs: {
    filesProvider: ImportUploadFilesProvider;
  };

  // Data

  public isProcessing = false;
  public accepts = [
    "text/csv",
    "text/x-comma-separated-values",
    "text/comma-separated-values"
  ].join(", ");

  // Methods

  public async uploadFiles() {
    const filesProvider = this.$refs.filesProvider as any;
    if (!filesProvider.hasValidAttachments) return;

    try {
      this.isProcessing = true;
      await filesProvider.uploadFiles();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.imports.all_files_successfully_uploaded")
      });
      this.$emit("success");
      this.$emit("close");
    } catch (e) {
      const error = e as AxiosError;
      const errorMessage = error.response?.data?.error?.message;

      if (!_.isEmpty(errorMessage)) {
        this.$_.set(error, "response.data.error.message", errorMessage);

        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      }
    } finally {
      this.isProcessing = false;
    }
  }

  // Compiuted

  public get uploadIsDisabled() {
    return this.isProcessing || this.$refs.filesProvider?.hasUploadErrors;
  }
}
